export default "<app-navigation title=\"{{title}}\"></app-navigation>"